var $ = require('jQuery');
var Uploader = require('uploader');
var Dialog = require('../../lib/dialog.js');

module.exports = function() {
  // Payments - on/off switch
  var onoffswitchContainer = $('.onoffswitch-container');
  var checkbox = onoffswitchContainer.find('.onoffswitch-checkbox');
  var form = onoffswitchContainer.find('form');

  var submitForm = function() {
    checkbox.prop('checked', !checkbox.prop('checked'));

    setTimeout(function() {
      form.submit();
    }, 500);
  };

  var dialog = new Dialog();

  onoffswitchContainer.find('.onoffswitch-label').on('click', function(event) {
    // The switch is going to be toggled manually
    event.preventDefault();

    // Turn on payments instantly
    if (!checkbox.prop('checked')) {
      submitForm();
      return;
    }

    // Turn off payments by asking for confirmation first
    dialog.show({ content: onoffswitchContainer.data('warning') }, submitForm);
  });

  // General settings
  function toggleSection(ele, section) {
    if ($(ele).is(":checked")) {
      $(section).show();
    } else {
      $(section).hide();
    }
  }

  $("#levy-processing-fee").on('change', function() {
    toggleSection("#levy-processing-fee", ".processing-fees");
  });

  $("#accept-paypal").on('change', function() {
    toggleSection("#accept-paypal", ".paypal-settings");
  });

  $("#accept-invoice").on('change', function() {
    toggleSection("#accept-invoice", ".invoice-instructions");
  });

  // Setup the Uploader, if included on the page.
  if ($("#uploader").length > 0) {
    new Uploader(uploaderOptions.clarify());
  }

  toggleSection("#levy-processing-fee", '.processing-fees');
  toggleSection("#accept-paypal", '.paypal-settings');
  toggleSection("#accept-invoice", ".invoice-instructions");
};
